import type {InterfaceStrings} from './strings'

export const es: InterfaceStrings = {
    nav: {
        beginSession: 'Empezar',
        faq: 'Preguntas',
        pricing: 'Precios',
        legal: 'Aviso legal',
        signIn: 'Iniciar sesión',
        viewPricing: 'Ver precios',
        signOut: 'Cerrar sesión',
        account: 'Cuenta',
        menu: 'Menú',
        closeMenu: 'Cerrar menú',
        mainNav: 'Navegación principal',
        sessions: {one: '{n} sesión', other: '{n} sesiones'},
    },
    footer: {
        selfHypnosisFor: 'Autohipnosis para',
        anxiety: 'La ansiedad',
        sleep: 'Dormir',
        stress: 'El estrés',
        confidence: 'La confianza',
        focus: 'La concentración',
        learn: 'Entender',
        ericksonian: 'Qué es la hipnosis ericksoniana',
        aiHow: 'Cómo funciona la hipnosis con IA',
        vsMeditation: 'Hipnosis o meditación',
        methods: 'Prácticas',
        languages: 'Idiomas',
    },
    page: {
        cta: 'Empieza tu sesión gratis',
        hint: 'Tu primera sesión es gratis',
        exploreFurther: 'Para seguir leyendo',
        disclaimer:
            'Quies es una herramienta de bienestar para la relajación y el autoconocimiento. No es un producto sanitario y no diagnostica, trata ni cura ninguna enfermedad. Si atraviesas una crisis de salud mental, acude a un profesional sanitario.',
        transcript: 'Transcripción',
        transcriptNote: 'Un fragmento de una sesión real de Quies, tal como se dijo.',
        breadcrumb: 'Ruta de navegación',
    },
    pricing: {
        selectPlan: 'Elegir este plan',
        subscribe: 'Suscribirse',
        perMonth: 'al mes',
        manageSubscription: 'Gestionar mi suscripción',
        replayFree: 'Volver a escuchar una sesión pasada es siempre gratis.',
        offerLead: 'Cada sesión empieza donde terminó la anterior.',
    },
    session: {
        chooseLanguage: 'Elige tu idioma',
        changeLanguage: 'Cambiar de idioma',
        changeVoice: 'Cambiar de voz',
        previewVoice: 'Escuchar a {voice}',
        stopPreview: 'Detener la muestra',
        continue: 'Continuar',
        composing: 'Quies está escribiendo tu sesión',
        preparing: 'Tu meditación se está preparando',
        pickingUp: 'retomamos donde lo dejaste',
        today: 'Hoy',
        yesterday: 'Ayer',
        loading: 'Cargando…',
        showEarlier: 'Mostrar anteriores ({count})',
        tryDifferentApproach: 'Probar otro camino',
        nothingAdded: 'Nada añadido',
        purchaseConfirmed: 'Compra confirmada',
        firstSessionNote: 'Tu primera sesión es gratis. Iniciarás sesión antes de escucharla.',
    },
    threshold: {
        title: 'Inicia sesión para escuchar',
        message: 'Tu primera sesión es gratis. No hace falta tarjeta.',
        google: 'Continuar con Google',
        sendLink: 'Envíame un enlace de acceso',
        sending: 'Enviando…',
        emailLabel: 'Correo electrónico',
        or: 'o',
        waitingTitle: 'Revisa tu correo',
        waitingBody: 'Hemos enviado un enlace de acceso a {email}.',
        sendAgain: 'Enviar de nuevo',
        googleInstead: 'Mejor iniciar sesión con Google',
        codeLabel: 'O escribe el código de 6 dígitos del correo',
        codeSubmit: 'Continuar',
        codeSubmitting: 'Comprobando…',
        codeWrong: 'Este código no es correcto.',
        codeDead: 'Este código ya no sirve. Usa el enlace del correo o pide uno nuevo.',
        errors: {
            invalidEmail: 'Escribe un correo electrónico válido.',
            rateLimited: 'Demasiados intentos. Vuelve a probar dentro de unos minutos.',
            sessionError: 'Algo ha fallado con tu acceso. Actualiza la página y vuelve a probar.',
            sendFailed: 'No se pudo enviar el correo. Inténtalo de nuevo.',
            sessionExpired: 'Tu acceso ha caducado. Actualiza la página y vuelve a probar.',
            generic: 'Algo ha fallado. Inténtalo de nuevo.',
        },
    },
    player: {
        play: 'Reproducir',
        pause: 'Pausa',
        playAgain: 'Escuchar de nuevo',
        seek: 'Posición',
        eyesClosed: 'Ojos cerrados',
        openEyes: 'Abrir los ojos',
        paused: 'En pausa',
        unavailable: 'Audio no disponible',
        untitled: 'Sesión de Quies',
    },
    failure: {
        turnFailed: 'Algo ha fallado por nuestra parte. Tu respuesta se conserva.',
        reconnecting: 'Reconectando…',
        refusalTitle: 'Tomemos otro camino',
        refusal: 'Una parte de tu mensaje no ha podido tener respuesta. Prueba a decirlo de otra forma o vuelve a enviarlo.',
        openElsewhere: 'Esta sesión también está abierta en otra ventana.',
        serviceDown: 'No se puede conectar con Quies en este momento. No se ha perdido nada de lo que has hecho.',
        sessionsUsedTitle: 'Ya has usado tus sesiones',
        voiceFailedTitle: 'Tu meditación está escrita',
        voiceFailed: 'Su voz no ha podido generarse ahora mismo. No se pierde nada, y volver a narrarla no cuesta nada.',
        voiceStopped: 'La voz se ha detenido a mitad de camino. Puede seguir desde donde se quedó.',
        streamMissing: 'Tu meditación está lista, pero no ha llegado a esta página.',
        tapToListen: 'Toca para escuchar',
        fileFailed: 'Esta grabación no se puede reproducir. La meditación puede volver a narrarse sin coste.',
        recordingGone: 'Esta grabación ya no se conserva.',
        purchaseCancelled: 'Compra cancelada. No se ha cobrado nada.',
        purchasePending: 'Tu pago está confirmado. Tus sesiones están tardando más de lo habitual en llegar.',
        checkoutFailed: 'No se ha podido completar el pago. No se ha cobrado nada.',
        sessionEnded: 'Esta sesión ha llegado a su fin.',
        busy: 'Quies tiene mucha demanda ahora mismo. Tu respuesta se conserva; vuelve a intentarlo dentro de un minuto.',
        tooLong: 'Esta sesión se ha hecho más larga de lo que Quies puede abarcar. Te la hemos devuelto.',
        notSaved: 'Este paso no ha podido guardarse. Vuelve a intentarlo para no perder el hilo.',
        meditationRefused:
            'Esta meditación no ha podido escribirse tal como la pediste. Dilo de otra forma o empieza de nuevo: te devolveremos esta sesión.',
        meditationRefusedUncharged:
            'Esta meditación no ha podido escribirse tal como la pediste. Dilo de otra forma o empieza de nuevo.',
        linkExpired: 'Tu enlace de acceso ha caducado. Pide uno nuevo.',
        oauthFailed: 'El inicio de sesión se ha interrumpido. Vuelve a intentarlo.',
        offline: 'Estás sin conexión. Tu respuesta se enviará en cuanto vuelvas.',
        voiceChanged: 'Tu voz ya no está disponible; otra voz narrará esta meditación.',
        voiceReturned: 'La voz sigue sin poder generarse. Te hemos devuelto esta sesión.',
        voiceFailedAgain: 'La voz sigue sin poder generarse.',
        voiceResuming: 'La voz se reanuda…',
        voiceLimited: 'En esta hora ya se han narrado varias meditaciones para ti. Vuelve a intentarlo un poco más tarde.',
        tryAgain: 'Reintentar',
        rephrase: 'Reformular',
        resume: 'Reanudar',
        voiceAgain: 'Volver a narrar',
        listen: 'Escuchar',
        continue: 'Continuar',
        begin: 'Empezar una sesión',
        signIn: 'Iniciar sesión',
        checkAgain: 'Comprobar de nuevo',
        sendLink: 'Enviar enlace mágico',
        useEmail: 'Usar el correo electrónico',
    },
}
